<template>
    <div class="common-skeleton-block"></div>
</template>

<script>
    import "@/components/Skeleton/Skeleton.scss";

    export default {
        name: "Skeleton",
    };
</script>
